import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/i18nContext';
import '../styles/EmailVerificationBanner.css';

const EmailVerificationBanner = () => {
  const { user, api } = useAuth();
  const { t } = useI18n();

  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);

  // Csak akkor mutassuk, ha az email nincs megerősítve
  if (!user || user.email_verified) return null;

  const handleResend = async () => {
    setLoading(true);
    try {
      await api.post('/auth/resend-verification');
      setSent(true);
    } catch {
      // csendes hiba
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="email-banner">
      <span className="email-banner-icon">📧</span>
      <span className="email-banner-text">{t('email.bannerText')}</span>
      {sent ? (
        <span className="email-banner-sent">✅ {t('email.resendSuccess')}</span>
      ) : (
        <button
          className="email-banner-btn"
          onClick={handleResend}
          disabled={loading}
        >
          {loading ? '...' : t('email.bannerResend')}
        </button>
      )}
    </div>
  );
};

export default EmailVerificationBanner;
